import { EventEmitter, Injectable } from '@angular/core';
import { CoreProvider } from './core';

@Injectable({ providedIn: 'root' })
export class NotificationsServiceProvider {

  private notificationsData: any = null;
  get notifications(): any {
    return this.notificationsData;
  }
  events: EventEmitter<any> = new EventEmitter<any>();

  private core: CoreProvider;
  constructor() {}

  public init(core: CoreProvider) {
    this.core = core;

    this.getNotifications();
    if (this.core.stable) {
      setInterval(()=>this.getNotifications(), 15000);
    } else {
      this.core.appIsStable.subscribe(() => {
        setInterval(()=>this.getNotifications(), 15000);
      });
    }
  }

  getNotifications() {
    // if (this.core.isLoggedIn) this.core.apiQuery.getNotifications().subscribe(Res => {
    //   this.setNewChanges(Res['User/GetNotifications']);
    // }, () => {});
  }

  private setNewChanges(res) {
    if (JSON.stringify(res)!=JSON.stringify(this.notificationsData)) {
      this.notificationsData = res;
      this.events.next(res);
    }
  }

}
